export const PLATFORMS = [
  {
    id: 'INSTAGRAM',
    name: 'Instagram',
    prefix: 'instagram.com/',
    placeholder: 'curator',
  },
  {
    id: 'YOUTUBE',
    name: 'Youtube',
    prefix: 'youtube.com/@',
    placeholder: 'curator',
  },
  {
    id: 'TWITTER',
    name: 'X (Twitter)',
    prefix: 'x.com/',
    placeholder: 'curator',
  },
  {
    id: 'TIKTOK',
    name: 'Tiktok',
    prefix: 'tiktok.com/@',
    placeholder: 'curator',
  },
  {
    id: 'ETC',
    name: '기타',
    prefix: '',
    placeholder: 'URL 주소를 기재해주세요',
  },
] as const;

export type PlatformId = (typeof PLATFORMS)[number]['id'];
export type Platform = (typeof PLATFORMS)[number];

// 플랫폼 관련 유틸리티 함수들
export const findPlatformById = (id: string): Platform | undefined =>
  PLATFORMS.find((platform) => platform.id === id);

export const getPlatformName = (id: string): string => {
  const platform = findPlatformById(id);
  return platform?.name || '';
};

export const getPlatformPrefix = (id: string): string => {
  const platform = findPlatformById(id);
  return platform?.prefix || '';
};

export const getPlatformPlaceholder = (id: string): string => {
  const platform = findPlatformById(id);
  return platform?.placeholder || '';
};
